module.exports = __webpack_public_path__ + "static/media/11.f6781ca6.png";